import { Component } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { GlobalFunctionsService } from 'app/core/services';

@Component({
  selector: 'fo-thanks',
  templateUrl: './thanks.page.html'
})
export class ThanksPage {
  returnUrl: string;

  constructor(private globalFunctionsService: GlobalFunctionsService, private config: AppConfig) {
    this.returnUrl = this.globalFunctionsService.returnUrl || this.config.getConfig('returnUrl') || '/courses';
    this.globalFunctionsService.showBasket(false);
    this.globalFunctionsService.showTabs(false);
  }
}
